import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" style={{
    paddingTop: "50px"
  }} data-id="element-139" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-140" data-mp="1mm7j0vzbjbew">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-141" data-mp="1hofpjxj0zh8l">
          <span aria-hidden="true" data-id="element-142" data-mp="ty1vk1gvr8bd">🏆 </span>Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-cta bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-143" data-mp="p00bbd7px2yb">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-cta px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-144" data-mp="13xkdydh56m1b">
            Physics &amp; Chemistry Ready Pack
          </span>

          <dl data-id="element-145" data-mp="2fad45juab2f9">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-146" data-mp="2add53svuqzxn">
                <dt className="text-ink/80" data-id="element-147" data-mp="pj5sehrdw6au">{row.label}</dt>
                <dd className="font-bold text-cta-dark" data-id="element-148" data-mp="ujboca4oseyq">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-149" data-mp="ul4yhzeidhbh">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-150" data-mp="zgka0kp1n14q">
                Total Value:
              </dt>
              <dd className="font-bold text-ink/40 line-through" data-id="element-151" data-mp="6u9918xiyy7e">$244 USD</dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-cta-dark" data-id="element-152" data-mp="bs1060qcigaj">
            Today only
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-153" data-mp="fsb4za2ej0nt">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-154" data-mp="kn8mz6hnskcu">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-ink" data-id="element-155" data-mp="3k6t4u8vu718t">
              $27
            </span>
            <span className="self-end pb-2 text-sm font-bold text-ink/60" data-id="element-156" data-mp="vfh72ehz15mi">
              USD
            </span>
          </p>

          <CtaButton className="mt-7 w-full" data-id="element-157" data-mp="qfmf07mgm9zv" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-158" data-mp="qetgftxnmqst">
            Instant Download · One-Time Payment · Lifetime Access · 30-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}